
import React from 'react';
import { Box, Typography, Button, Stack } from '@mui/material';

interface Option {
  title: string;
  postbackText?: string;
  description?: string;
  type?: string;
}

interface MessageContent {
  text?: string;
  button_reply?: string;
  caption?: string;
  options?: Option[];
}

interface MessageType {
  content?: MessageContent;
}

interface Props {
  message: MessageType;
  onQuickReplyClick?: (option: Option) => void;
}
const formatText = (text: any): string => {
  if (typeof text !== 'string') return '';
  
  return text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/\*(.*?)\*/g, '<b>$1</b>')        
    .replace(/_(.*?)_/g, '<i>$1</i>')        
    .replace(/~(.*?)~/g, '<s>$1</s>')       
    .replace(/```(.*?)```/g, '<code>$1</code>') 
    .replace(/(https?:\/\/[^\s]+)/g, '<a href="$1" target="_blank" rel="noopener noreferrer">$1</a>') // link
    .replace(/\n/g, '<br />');                 
};

const MessageButtonQuickReply: React.FC<Props> = ({ message, onQuickReplyClick }) => {
  const content = message?.content || {};
  const mainText = content?.text || content?.button_reply || 'Text message not found';
  const options = content?.options || [];
  const caption = content?.caption;

  return (
    <Box>
      {/* ✅ Main message */}
      <Typography variant="body1" fontWeight="bold" sx={{ mb: 2, whiteSpace: 'pre-wrap' }} dangerouslySetInnerHTML={{ __html: formatText(mainText) }}
>
        {/* {mainText} */}
      </Typography>

      {/* ✅ Quick reply options */}
      <Stack spacing={1}>
        {options.map((opt, index) => (
          <Button
            key={index}
            variant="outlined"
            size="small"
            onClick={() => onQuickReplyClick?.(opt)}
            sx={{
              textTransform: 'none',
              borderRadius: '20px',
              fontWeight: 500,
              justifyContent: 'flex-start',
              color: 'black',
              borderColor: 'grey.400',
            }}
          >
            {opt.title}
          </Button>
        ))}
      </Stack>

      {/* ✅ Optional caption */}
      {caption && (
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{ mt: '8px', display: 'block', whiteSpace: 'pre-wrap' }}
          dangerouslySetInnerHTML={{ __html: formatText(caption) }}
        >
          {/* {caption} */}
        </Typography>
      )}
    </Box>
  );
};

export default MessageButtonQuickReply;
